// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"369":"59c8bd7b","406":"08a124a0","662":"0e01f4e2"}[chunkId] + ".css";
};